export function setTranslateX(node: HTMLElement, value: number): void {
  node.setAttribute(
    'style',
    `
    -webkit-transform: translateX(${value}px);
    transform: translateX(${value}px)
  `
  );
}

export function getTranslateX(node: HTMLElement): number {
  if (!node) return 0;
  const {transform, webkitTransform} = window.getComputedStyle(node);
  const matrix = new WebKitCSSMatrix(transform || webkitTransform);
  return matrix.m41;
}
